import React from 'react'
import { compose } from 'recompose'
import { connect as formikConnect } from 'formik'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { connect } from 'react-redux'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'

import { fetchAgents } from 'SRC/modules/users/Profile/actions'
import { getAgents, getAgentsLoading } from 'SRC/modules/users/Profile/selectors'

class Agent extends React.Component {
	cookies = new CookiesHelper()

	componentDidMount () {
    const { isAuthorized, fetchAgents } = this.props

		const userId = this.cookies.get('userId')
		const token = this.cookies.get('token')

    if (isAuthorized && userId && token) fetchAgents(userId, token)
  }

	getAgentOptions = () => {
		const { agents } = this.props

		if (Array.isArray(agents)) {
			return agents.map(agent => ({
				id: `${agent.id}`,
				label: agent.name,
				value: `${agent.id}`
			}))
		}

		return []
	}

	render() {
		const { isAgentsLoading, formik } = this.props

		const options = this.getAgentOptions()
		
		return (
			<Wrapper>
				<SelectDropdown
					id='agent'
					title='Agent'
					isDisabled={isAgentsLoading || !Array.isArray(options) || !options.length}
					value={formik.values.agent || -1}
					options={options}
					onChange={agent => {
						console.log('agent', agent)
						formik.setFieldValue('agent', agent)
					}}
				/>
			</Wrapper>
		)
	}
}

const mapStateToProps = state => {
	return {
		agents: getAgents(state),
		isAgentsLoading: getAgentsLoading(state),
		isAuthorized: getIsAuthorized(state)
	}
}

const enhance = compose(
	connect(mapStateToProps, { fetchAgents }),
	formikConnect
)

export default enhance(Agent)
